import http from '@/utils/ajax'
import { PENDMTR_INIT_LOADING, PENDMTR_INIT_SUCCESS, PENDMTR_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  pendingMtr: {
    init: 0,
    menu: {},
    noQuote: null,
    lastUpdated: null
  }
}

const getters = {

}

const actions = {
  async initPendingMtr({ commit, state }) {
    commit(PENDMTR_INIT_LOADING)
    const apiUrl = state.permitWidgets.pendingMtr
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const { data } = result
        Object.assign(data, {
          menu: menu
        })
        commit(PENDMTR_INIT_SUCCESS, data)
      } catch (error) {
        commit(PENDMTR_INIT_FAIL)
      }
    } else {
      commit(PENDMTR_INIT_FAIL)
    }
  }
}

const mutations = {
  [PENDMTR_INIT_LOADING](state) {
    state.pendingMtr.init = 0
  },
  [PENDMTR_INIT_SUCCESS](state, data) {
    const { pendingMtr } = state
    pendingMtr.menu = data.menu
    pendingMtr.init = 1
    pendingMtr.lastUpdated = new Date()
    pendingMtr.noQuote = data.noQuote
  },
  [PENDMTR_INIT_FAIL](state) {
    state.pendingMtr.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
